module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-05-75109e023109180fa8048d92fe3af474.jpg";